import { APIPaginatedRequest, getFetcherV2 } from "shared/api/api";
import { clientV2 } from "shared/api/axios";
import { Repair } from "shared/api/repairs/v2/api";
import { ServiceCenter } from "shared/api/serviceCenters/v2/api";
import { createURL } from "shared/api/utils";

export const WORK_ORDERS_BASE_ROUTE = "workOrders";

export interface WorkOrder {
  ID: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  assetID: string;
  assetName: string | null;
  date: string | null;
  externalID: string | null;
  status: string | null;
  outOfServiceTime: string | null;
  inServiceTime: string | null;
  downtime: string | null;
  notes: string | null;
  costLabor: number | null;
  costOther: number | null;
  costParts: number | null;
  costTotal: number | null;
  currencyCode: "USD" | "EUR" | null;
  serviceCenterID: string | null;
  serviceCenter: ServiceCenter | null;
  inferredDowntimeStart: string | null;
  inferredDowntimeEnd: string | null;
  inferredDowntime: string | null;
  odometer: number | null;
  repairs: Repair[];
  hasLinkedWorkOrderVerification: boolean;
  workOrderNotes: WorkOrderNote[];
}

export interface WorkOrderNote {
  ID: string;
  notes: string;
  timestamp: string;
}

export const listWorkOrdersRequestURI = ({
  ...params
}: APIPaginatedRequest): string =>
  clientV2.getUri({
    method: "get",
    url: createURL([WORK_ORDERS_BASE_ROUTE]),
    params,
  });

export const listWorkOrders = (args: APIPaginatedRequest) =>
  getFetcherV2<WorkOrder[]>(listWorkOrdersRequestURI(args));

export const countWorkOrdersRequestURI = ({
  ...params
}: APIPaginatedRequest): string =>
  clientV2.getUri({
    method: "get",
    url: createURL([WORK_ORDERS_BASE_ROUTE, "count"]),
    params,
  });

export interface GetWorkOrderRequest {
  id: string;
}

export const getWorkOrderRequestURI = ({ id }: GetWorkOrderRequest): string =>
  clientV2.getUri({
    method: "get",
    url: createURL([WORK_ORDERS_BASE_ROUTE, id]),
  });
